const Location = {
  pack: (type, name) => [type, name].join(','),
  unpack: (location) => location.split(',')
}

export default Location;
